import styled from 'styled-components';

export const StyledEmployeeTable = styled.div`
  padding-top: ${({ theme }) => theme.spacing(8)};
  :last-child {
    padding-bottom: ${({ theme }) => theme.spacing(6)};
  }
`;

export const StyledProfileImage = styled.img`
  height: ${({ theme }) => theme.spacing(9)};
  cursor: pointer;
`;
